import React from 'react';
import { Grid } from '@material-ui/core';
import i18n from 'i18n';

export interface Props {
  type: string;
}

const ScreenStatus = ({ type }: Props) => {
  const RenderItem = {
    LIGADA: 'ENVIRONMENTS_PAGE.ON_INSTANCE_KEY',
    OPERACIONAL: 'ENVIRONMENTS_PAGE.OPERATIONAL_INSTANCE_KEY',
    BLOQUEADA: 'ENVIRONMENTS_PAGE.BLOCKED_INSTANCE_KEY',
    PARADA: 'ENVIRONMENTS_PAGE.STOPPED_INSTANCE_KEY',
    INACESSIVEL: 'ENVIRONMENTS_PAGE.INACCESSIBLE_INSTANCE_KEY',
    PARANDO: 'ENVIRONMENTS_PAGE.STOPPING_INSTANCE_KEY',
    TERMINANDO: 'ENVIRONMENTS_PAGE.ENDING_INSTANCE_KEY',
    INICIALIZANDO: 'ENVIRONMENTS_PAGE.INITIALIZING_INSTANCE_KEY',
    ATIVANDO: 'ENVIRONMENTS_PAGE.ACTIVATING_INSTANCE_KEY',
  };
  return (
    <Grid data-testid={'autosky-screenstatus'}>{i18n.t(RenderItem[type])}</Grid>
  );
};

export default ScreenStatus;
